export const GET_EXTERNAL_MODULES_START = 'GET_EXTERNAL_MODULES_START';
export const GET_EXTERNAL_MODULES_SUCCESS = 'GET_EXTERNAL_MODULES_SUCCESS';
export const GET_EXTERNAL_MODULES_FAILURE = 'GET_EXTERNAL_MODULES_FAILURE';
